import ValidService from "../../../service/ValidService";
let model = {};

// dữ liệu form
model.dataForm = {    
    ngon_ngu: null, //string, optional // Mã ngôn ngữ
    an_bai_viet: null, //boolean, optional // Cho biết bài viết có bị ẩn hay không
    danh_muc_id: null, //IdRef, optional // Mã danh mục tin tức
    doi_tuong_hien_thi: [], //array of string, optional // Đối tượng sẽ nhìn thấy bài viết này, các giá trị hợp lệ: tourist, tourguide
    tieu_de: null, //string, optional // Tiêu đề bài viết
    noi_dung: null, //string, optional // Nội dung bài viết
    anh: { //object, optional // Các thể loại ảnh của tin tức
        anh_dai_dien: null, //IdRef, optional // Mã ảnh đại diện của tin tức
        anh_tin_tuc: [], //array of IdRef, optional // Danh sách ảnh của tour
    },
    dia_diem: { //object, optional // Thông tin địa điểm của tin tức
        dia_diem: null, //string, optional // Địa điểm
        province_id: null, //IdRef, optional // Mã tỉnh
        district_id: null, //IdRef, optional // Mã huyện
        lng: null, //double, optional // Kinh độ (longitude)
        lat: null //double, optional // Vĩ độ (latitude)
    },
    thoi_diem_dang_bai: null, //datetime, optional // Thời điểm đăng bài
};

// validation form
model.validForm = {   
    ngon_ngu: [ValidService.required], //string, optional // Mã ngôn ngữ
    an_bai_viet: [], //boolean, optional // Cho biết bài viết có bị ẩn hay không
    danh_muc_id: [ValidService.required], //IdRef, optional // Mã danh mục tin tức
    doi_tuong_hien_thi: [], //array of string, optional // Đối tượng sẽ nhìn thấy bài viết này, các giá trị hợp lệ: tourist, tourguide
    tieu_de: [ValidService.required], //string, optional // Tiêu đề bài viết
    noi_dung: [], //string, optional // Nội dung bài viết
    anh: { //object, optional // Các thể loại ảnh của tin tức
        anh_dai_dien: [], //IdRef, optional // Mã ảnh đại diện của tin tức
        anh_tin_tuc: [], //array of IdRef, optional // Danh sách ảnh của tour
    },
    dia_diem: { //object, optional // Thông tin địa điểm của tin tức
        dia_diem: [], //string, optional // Địa điểm
        province_id: [], //IdRef, optional // Mã tỉnh
        district_id: [], //IdRef, optional // Mã huyện
        lng: [], //double, optional // Kinh độ (longitude)
        lat: [] //double, optional // Vĩ độ (latitude)
    },
    thoi_diem_dang_bai: [ValidService.required], //datetime, optional // Thời điểm đăng bài
};

// dữ liệu mẫu các form khác
model.dataFormOther = {
    fileUploadOption: {
        AnhDaiDien: {
          limit: 1,
          accept: ".jpg, .png, .jpeg",
          dialogImageUrl: "",
          dialogVisible: false,
          fileList: []
        },
        AnhTinTuc: {
          limit: null,
          accept: ".jpg, .png, .jpeg",
          dialogImageUrl: "",
          dialogVisible: false,
          fileList: []
        }
      },
    ggmapOption:{
        center: { lat:21.022736, lng:105.8019441 },
        markers: [],
        places: [],
        currentPlace: null
    }
};

// validation các form khác
model.validFormOther = {
};

model.trangThai = [
    {
        code: "true",
        text: "Ẩn"
    },
    {
        code: "false",
        text: "Hiện"
    }
];

model.tableRules = {
    data: [],
    lengthMenu: [10, 20, 50, 100, 500],
    allowPaging: true,
    allowSorting: true,
    allowSelect: false,
    showFormSearch: false,
    showUrl: true,
    total: 0,
    page: 1,
    limit: 10,
    offset: 0,
    sort: "",
    defaultSort: ["thoi_diem_dang_bai", "descending"],
    filters: "",
    recordSelected: [],
    dataSearch: {
        value: {
            tieu_de: "",
            'dia_diem.dia_diem': "",
            thoi_diem_tao: "",
            danh_muc_id: "",
            doi_tuong_hien_thi: "",
            ngon_ngu: "",
            an_bai_viet:""
        },
        valid: {
            tieu_de: [],
            'dia_diem.dia_diem': [],
            thoi_diem_tao: [],
            danh_muc_id: [],
            doi_tuong_hien_thi: [],
            ngon_ngu: [],
            an_bai_viet:[]
        },
        operator: {
            tieu_de: ":regex_i:", //:regex:, $vn_text=Viêt nam
            'dia_diem.dia_diem': ":regex_i:",
            doi_tuong_hien_thi: ":in:",
            thoi_diem_tao: ":in_that_day:",
            thoi_diem_dang_bai: ":in_that_day:",
        }
    }
  };

export default model;